
import { ListMetadata } from '../../../models/list-metadata.model';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';

import { HttpClientService } from 'app/services/httpClient/httpclient.service';
import { DistributionCluster3, DistributionList3, DistributionListDetails, DistributionPromo } from 'app/views/campaign-3/models/campaign-3.model';
import { HttpParams } from '@angular/common/http';


@Injectable()
export class DistributionList3Service {
  private readonly baseUrl = 'koncentro-promo/campaign';
  private distributionListDetail: DistributionList3 | null = null;

  constructor(private http: HttpClientService) {}

  // Gestione dati locali
  setData(data: DistributionList3): void {
    this.distributionListDetail = data;
  }

  getData(): DistributionList3 | null {
    return this.distributionListDetail;
  }

  resetData(): void {
    this.distributionListDetail = null;
  }

  // Recupera la lista completa delle distributionList
  list(
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<any>; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    const paramsString = params.toString().replace(/\+/g, '%2B'); // Converte in stringa e sostituisce il "+"

    return this.http.getPaged(`${this.baseUrl}/distribution_list/getDistributionListComplete?onlyActive=true&limit=999999&${paramsString}`);
  }


  // Creazione di una nuova distribution list
  createDistributionList(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/distribution_list`, data);
  }

  // Aggiunta di cluster a una distribution list
  onAddSelectedClusters(distributionListId: number, clusterArray: number[]): Observable<any> {
    return this.http.post(`${this.baseUrl}/distribution_list_cluster_head/cluster-head`, {
      distribution_list_id: distributionListId,
      cluster_head_id_array: clusterArray,
    });
  }

  // Recupero cluster disponibili
  getDistributionListAvailableClusters(fatherDistribution: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/distribution_list/getDistributionListAvailableClusters?
      limit=99999&distribution_list_id=${fatherDistribution}`);
  }

  // Recupero cluster di una specifica distribution list
  getDistributionListDetails(id: number): Observable<Array<DistributionCluster3>> {
    return this.http.get(`${this.baseUrl}/distribution_list/getDistributionListClusters?
      limit=99999&distribution_list_id=${id}`);
  }

  // Salvataggio di una nuova distribution list
  saveNewDistributionList(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/distribution_list`, payload);
  }

  // Modifica di una distribution list
  editDistributionList(payload: any, idDistributionListEdit: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/distribution_list/${idDistributionListEdit}`, payload);
  }

  // Rimozione di un cluster da una distribution list
  deleteClusterHeadFromDistributionList(fatherDistribution: any, clusterIdToDelete: any): Observable<Array<DistributionCluster3>> {
    return this.http.post(`${this.baseUrl}/distribution_list_cluster_head/removeClusterHead`, {
      cluster_head_id: clusterIdToDelete,
      distribution_list_id: fatherDistribution.distributionListId,
    });
  }

  // Eliminazione di una distribution list
  deleteDistributionList(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/distribution_list/${id}`);
  }

  // Recupero delle promo azioni
  getActionPromoList(
    offset: number | null = null,
    limit: number | null = null,
    search?: Array<{ key: string; value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<DistributionPromo>; metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.http.getPaged(`${this.baseUrl}/message-instance?${params}`);
  }

  // Recupero delle promo associate alle distribution list
  getDistributionPromoList(
    distribution_list_id: string
  ): Observable<{ data: Array<DistributionPromo>; metadata: ListMetadata }> {
    const params = new HttpParams()
      .set('distribution_list_id', distribution_list_id)
      .set('sort', 'status')
      .set('sort_dir', '-1');

    return this.http.getPaged(`${this.baseUrl}/message-instance/getActionsWithDistributionList?${params.toString()}`);
  }

}




// WEBPACK FOOTER //
// ./src/app/views/distribution-list/services/distribution3.service.ts